window.addEventListener('DOMContentLoaded', () => {

    if(PCHEvents) {
        PCHEvents.cmd.push(() => {
            PCH.uninav.controller.onLevelUpResolved()
                .then(() => {
                    if(PCH?.uninav?.controller?.user?.justLeveledUp) {
                        PCHEvents.triggerEvent('tokens_earned');
                        PCHEvents.triggerEvent('level_up');
                        PCH.uninav.controller.user.justLeveledUp = false;
                    }
                });
        });
    }

});
